export default "__VITE_ASSET__ed8bc7ef__"